import { Link } from "react-router-dom";

// Hero.jsx
export default function Hero() {
  return (
    <section className="bg-slate-50 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-50 rounded-full blur-3xl opacity-40 -z-10" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-50 rounded-full blur-3xl opacity-40 -z-10" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        {/* Top Badge - Now at the top of the section */}
        <div className="text-center mb-8">
          <span className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700">
            ✨ Fresh Glow Deals • Up to 50% OFF
          </span>
        </div>

        {/* Main Content - Two Column Layout */}
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Left Column - Image with Floating Card */}
          <div className="w-full lg:w-1/2">
            <div className="relative bg-white rounded-3xl shadow-md border border-slate-100 p-4 sm:p-6">
              <img
                src="/assests/productimg/skincare/8.webp"
                alt="Skincare essentials"
                className="w-full h-64 sm:h-80 object-contain rounded-2xl"
              />

              {/* Floating card - Repositioned */}
              <div className="absolute bottom-4 right-4 w-90">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-md border border-slate-100 px-4 py-3 flex items-center justify-between gap-3">
                  <div>
                    <p className="text-xs uppercase tracking-wide text-slate-400">
                      Featured Offer
                    </p>
                    <p className="text-sm font-semibold text-slate-900">
                      Save 30% on best-selling skincare
                    </p>
                  </div>
                  <Link
                    to={"/categories/SkinCare"}
                    className="text-xs font-semibold text-emerald-700 hover:text-emerald-800"
                  >
                    Shop now →
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Content and Stats */}
          <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
            {/* Content Section */}
            <div className="text-center lg:text-left mb-8">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight mb-4">
                Reveal your{" "}
                <span className="text-[#fe7590]">best skin</span> with trusted care.
              </h1>

              <p className="text-slate-600 text-sm sm:text-base mb-6">
                Explore dermatologist-loved formulas, gentle cleansers, serums, and moisturizers. 
                Build a routine that hydrates, repairs, and protects—morning to night.
              </p>

              {/* Actions */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-8">
                
              </div>
            </div>

            {/* Stats Section - Now integrated into the right column */}
            <div className="w-full">
              <div className="flex flex-wrap justify-center lg:justify-start gap-8 text-xs sm:text-sm text-slate-500">
                <div className="text-center">
                  <p className="font-semibold text-slate-800 text-lg">50K+</p>
                  <p>Radiant customers</p>
                </div>
                <div className="text-center">
                  <p className="font-semibold text-slate-800 text-lg">2 days</p>
                  <p>Average delivery time</p>
                </div>
                <div className="text-center">
                  <p className="font-semibold text-slate-800 text-lg">Simple</p>
                  <p>Returns & refunds</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
